import moment from "moment";

export const convertJustTimeToUtc = (time) => {
  return window.moment(time, "hh:mm a").utc().format("hh:mm a");
};
export const convertJustTimeFromUtcToCurrentTimeZone = (time) => {
  return window.moment.utc(time, "hh:mm a").local().format("hh:mm a");
};
